import React from "react";
import styled from "styled-components";
import Logo from "../Logo";
import { getThemeColor } from "../../utils";
import Sperm from "../atoms/Sperm";

const Screen = styled.div`
  display: ${({ loading }) => (loading ? "flex" : "none")};
  opacity: ${({ loading }) => (loading ? 1 : 0)};
  background: ${getThemeColor("purpleDark")};
  align-items: center;
  justify-content: center;
  position: fixed;
  right: 0;
  left: 0;
  top: 0;
  bottom: 0;
  z-index: 9;
  transition: opacity 500ms, bottom 1000ms, top 1000ms;
`;

export default ({ loading }) =>
  <Screen loading={loading}>
    <Sperm color="teal" />
  </Screen>;



// WEBPACK FOOTER //
// ./src/components/blocks/LoadingScreen.js